import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Common modal width class: 342px on mobile, 600px on tablet/desktop
 */
export const modalWidthClass = "w-[342px] md:w-[600px]";
